import React from 'react'
import { useLocation } from 'react-router'

import { Header } from '../Header/Header'
import { Footer } from '../Footer/Footer'
import { Notifications } from '../../components/Notifications/Notifications'

import './PageContainer.scss'

export const PageContainer = ({ children }) => {
  const location = useLocation()

  return (
    <div className="page-container">
      <Header />
      <main>
        { children }
      </main>
      <Footer yellow={ location.pathname === '/' }/>
      <Notifications />
    </div>
  )
}